import { render, staticRenderFns } from "./MandalaView.vue?vue&type=template&id=156355f8&scoped=true"
import script from "./MandalaView.vue?vue&type=script&lang=js"
export * from "./MandalaView.vue?vue&type=script&lang=js"
import style0 from "./MandalaView.vue?vue&type=style&index=0&id=156355f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156355f8",
  null
  
)

export default component.exports